<template>
  <div :style="{ '--sidebar-width': sidebarWidth }">
    <router-view />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const sidebarWidth = computed(() => store.getters.sidebarWidth);
</script>


<style>
body, html {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0;
  padding: 0;
}
* {
    box-sizing: border-box;
}
:root {
    --sidebar-width: 160px;
}
header {
  display: none;
}
</style>
